import * as React from "react";
const PrintIcon = (props) => (
	<svg
		width={20}
		height={20}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M16 15c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C19 13.398 19 12.932 19 12V8.197c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C17.506 5.013 16.988 5.001 16 5m0 0H4m12 0H4m12 0v-.803c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C14.48 1 13.92 1 12.8 1H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 2.52 4 3.08 4 4.2V5m0 0c-.988 0-1.507.013-1.908.218a2 2 0 0 0-.874.874C1 6.52 1 7.08 1 8.2V12c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.082 1.083C2.602 15 3.068 15 4 15m4-6h4m-5 4h6c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.082C16 14.602 16 15.068 16 16s0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C14.398 19 13.932 19 13 19H7c-.932 0-1.398 0-1.766-.152a2 2 0 0 1-1.082-1.082C4 17.398 4 16.932 4 16s0-1.398.152-1.766a2 2 0 0 1 1.082-1.082C5.602 13 6.068 13 7 13"
			stroke={props.color ? props.color : "#fff"}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default PrintIcon;
